import { useQuery } from '@tanstack/react-query';
import apiClient from './apiClient';

export const stockMovementKeys = {
  all: ['stockMovements'],
  list: (filters = {}) => [...stockMovementKeys.all, 'list', filters],
  byArticle: (articleId) => [...stockMovementKeys.all, 'byArticle', articleId],
};

const buildMovementParams = (filters = {}) => {
  const params = {};

  if (filters.uuid_inventory_article) {
    params.uuid_inventory_article = filters.uuid_inventory_article;
  }
  if (filters.uuid_warehouse) {
    params.uuid_warehouse = filters.uuid_warehouse;
  }
  if (filters.movement_type) {
    params.movement_type = filters.movement_type;
  }

  return params;
};

export const useStockMovements = (filters = {}, options = {}) => {
  const params = buildMovementParams(filters);

  return useQuery({
    queryKey: stockMovementKeys.list(params),
    queryFn: async () => {
      const response = await apiClient.get('stock_movements', { params });
      return response.data;
    },
    enabled: Boolean(filters.uuid_inventory_article),
    staleTime: 60 * 1000,
    ...options,
  });
};

export const useStockMovementsByArticle = (articleId, options = {}) => {
  return useQuery({
    queryKey: stockMovementKeys.byArticle(articleId),
    queryFn: async () => {
      const response = await apiClient.get(`stock_movements/by-article/${articleId}`);
      return response.data;
    },
    enabled: !!articleId,
    staleTime: 60 * 1000,
    ...options,
  });
};
